import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import HomeHero from "../../components/HomeHero";
import Slider from "../../components/Slider";
import TrustedMediaList from "../../components/TrustedMediaList";
import CoinInterestRateCard from "../../components/CoinInterestRateCard";
import PartialContentTemplate from "../../components/ContentComponents/PartialContentTemplate";

import Opinions from "../../components/partials/home-page/opinions.en";
import PersonalizeYourInvestmentPortfolio from "../../components/partials/home-page/personalize-your-investment-portfolio.en";
import FiatDepositsMadeEasy from "../../components/partials/home-page/fiat-deposits-made-easy.en";
import HowDepositMoney from "../../components/partials/home-page/how-deposit-money.en";
import StartInvestingInDigitalAssetsWithZipmex from "../../components/partials/home-page/start-investing-in-digital-assets-with-zipmex.en";

import GetOnBoard from "../../components/ContentComponents/GetOnBoard";
import Link from "../../components/Link";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getAcfPartialContent } from "../../utils";
import PartialPointList from "../../components/PartialPointList";

const RegulatedBy = ({ regulatedByLabel }) => {
  return (
    <div className="container grid-container pb-5 px-4">
      <div className="grid-col-12 d-flex align-items-center justify-content-center justify-content-lg-start">
        <p className="has-normal-font-size">{regulatedByLabel} </p>
        <div className="mb-1 ml-3">
          <>
            <a
              href="http://bappebti.go.id/aktualita/detail/5683"
              target="_blank"
              rel="noreferrer noopener"
            >
              <StaticImage
                src={"../../assets/images/bappebti-colored.png"}
                alt="Bappebti"
                height={36}
                placeholder="blurred"
              />
            </a>
            <a
              href="https://pse.kominfo.go.id/sistem/2532"
              target="_blank"
              rel="noreferrer noopener"
              className="ml-3"
            >
              <StaticImage
                src={"../../assets/images/kemkominfo-colored.svg"}
                alt="Kemkominfo"
                height={36}
                placeholder="blurred"
              />
            </a>
          </>
        </div>
      </div>
    </div>
  );
};

const HomeLayout = ({ data, isIndo, t }) => {
  const digitalAssetsContent = getAcfPartialContent(data.digitalAssetsContent);

  return (
    <>
      <HomeHero
        content={data.heroContent.edges[0].node.acfHeroSections}
        heroCryptoRev={data.heroCryptoRev.nodes[0]}
        heroImage={data.heroImage.publicURL}
      />
      {isIndo && (
        <RegulatedBy regulatedByLabel={t("home.heroHome.regulatedBy")} />
      )}

      {data.promos && (
        <Slider
          classNames="container px-0"
          items={data.promos.edges.map(({ node: { acfPromotions } }) => ({
            linkTo: acfPromotions.proUrl,
            image:
              acfPromotions.proImage.localFile.childImageSharp.gatsbyImageData,
          }))}
          settings={{
            default: {
              slidesToShow: data.promos.edges.length >= 3 ? 3 : 2,
            },
          }}
        />
      )}

      <TrustedMediaList links={data.mediaLinks} />

      <PartialContentTemplate
        headerHTML={digitalAssetsContent.pHeading}
        contentHTML={digitalAssetsContent.pContent}
        btnHref={digitalAssetsContent.pButtonUrl}
        btnLabel={digitalAssetsContent.pButtonText}
        btnClassNames="button-secondary"
        contentClassNames="text-dark"
      >
        <div className="grid-container">
          {data.coinInterestRates.edges.map(
            ({ node: { acfCoinInterestRates } }, i) => (
              <CoinInterestRateCard
                key={`coin-interest-rate-card-${i}`}
                classNames="grid-col-12 grid-col-sm-6 grid-col-md-4 grid-col-xl-2 mt-4 mb-2"
                imgSrc={acfCoinInterestRates.cirCoinIcon.localFile.publicURL}
                imgHeight={acfCoinInterestRates.cirCoinIcon.mediaDetails.height}
                imgWidth={acfCoinInterestRates.cirCoinIcon.mediaDetails.width}
                rate={`${acfCoinInterestRates.zipupInterateRateV2.vip4.rate}%`}
                annualPercentageYieldLabel={t(
                  "home.digitalAssets.annualPercentageYield"
                )}
                apyLabel={t("home.digitalAssets.apy")}
                data-sal="slide-up"
                data-sal-duration="100"
                data-sal-easing="ease-in-quad"
                data-sal-delay={`${i + 1}00`}
              />
            )
          )}
        </div>
      </PartialContentTemplate>

      <PartialContentTemplate headerHTML={t("home.whyZipmex.title")}>
        <PartialPointList
          points={data.whyZipmexContent.edges}
          asHeader="h3"
          isAlignHorizontally={true}
          contentClassNames="text-small mb-5"
          isDataScroll={true}
        />
      </PartialContentTemplate>

      <PersonalizeYourInvestmentPortfolio content={data.personalizeContent} />

      {isIndo && (
        <>
          <FiatDepositsMadeEasy content={data.fiatDepositsContent} />

          <HowDepositMoney
            content={data.howDepositContent}
            iconInfo={data.iconInfo}
          />
        </>
      )}

      <StartInvestingInDigitalAssetsWithZipmex
        content={data.personalizeContent}
        imageBuyBtc={data.imageBuyBtc}
      />

      {/* <PartialContentTemplate
        headerHTML={t("home.opinions.title")}
        btnHref="/learn/"
        btnLabel={t("common.learnMore")}
        btnClassNames="button-secondary"
      >
        <Slider
          classNames="container px-0"
          items={data.opinions.edges.map(({ node }) => ({
            linkTo: `/learn/${node.slug}/`,
            image:node.featuredImage.node.localFile.childImageSharp
            .gatsbyImageData,
            title: node.title
          }))}
          settings={{
            default: {
              slidesToShow: data.opinions.edges.length >= 4 ? 4 : 2,
              autoplay: true,
              infinite: true,
              arrows: true
            },
            mediumScreen: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
            smallScreen: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false
            }
          }}
        />

      </PartialContentTemplate> */}

      <div id="opinions" className="home">
        <div className="container py-5 my-5">
          <h2 className="mb-5 pb-5 text-center">{t("home.opinions.title")}</h2>
          <Opinions articles={data.opinions} />
          <div className="text-center mt-5 mb-2">
            <Link className="button button-secondary" to={`/learn/`}>
              {t("common.learnMore")}
            </Link>
          </div>
        </div>
      </div>

      <GetOnBoard content={getAcfPartialContent(data.getOnBoardContent)} />
    </>
  );
};

export default HomeLayout;
